import { gql } from '@src/lib/gql'

export const ADVISOR_LEDGER_ENTRIES = gql`
  query AdvisorLedgerEntries($pageSize: Int, $page: Int) {
    advisorLedgerEntries(pageSize: $pageSize, page: $page) {
      items {
        id
        advisorLedgerEntryId
        userId
        entryTypeKey
        entryType {
          id
          key
          title
        }
        amountUsd
        availableAt
        advisorSessionId
        advisorPayoutId
        description
        createdAt
      }
      pagination {
        itemCount
        hasNextPage
        page
        pageSize
        pageCount
      }
    }
  }
`
